<template>
	<div class="fixed-nav" :class="{ shown }">
		<slot></slot>
	</div>
</template>

<script>
export default {
	props: [ 'scroll' ],
	data: () => ({
		shown: false
	}),
	mounted() {
		window.addEventListener('scroll', (event) => {
			window.cancelAnimationFrame(this.timeout)

			this.timeout = window.requestAnimationFrame(() => {
				this.shown = window.scrollY > this.scroll
			})
		})
	}
}
</script>

<style lang="scss" scoped>
.fixed-nav {
	left: 0;
	height: 0;
	opacity: 0;
	overflow: hidden;
	position: fixed;
	top: 0;
	transition: 0.66s opacity;
	width: 100%;
	z-index: 1000;

	&.shown {
		height: auto;
		opacity: 1;
	}
}
</style>